module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": "Link Whatsapp Channel",
      "width": "500px",
      "visible": _vm.showDialog,
      "append-to-body": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.showDialog = $event
      }
    }
  }, [(!_vm.whatsappChannelId && !_vm.isAuthed) ? _c('div', {
    staticClass: "dialog-body"
  }, [_c('p', [_vm._v("Please choose your country and enter your phone number.")]), _vm._v(" "), _c('el-form', {
    attrs: {
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Country"
    }
  }, [_c('country-code-selector', {
    staticClass: "country-selector",
    attrs: {
      "browserCountryCode": _vm.userCountryCode,
      "selectedCountry": _vm.selectedCountry.code
    },
    on: {
      "onCountryChanged": _vm.handleCountryChanged
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Phone number"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Phone number"
    },
    model: {
      value: (_vm.phoneNumber),
      callback: function($$v) {
        _vm.phoneNumber = $$v
      },
      expression: "phoneNumber"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("\n            " + _vm._s(_vm.selectedCountry.flag) + "\n            " + _vm._s(_vm.selectedCountry.dial_code) + "\n          ")])], 2), _vm._v(" "), _c('small', {
    staticClass: "muted"
  }, [_vm._v("Phone number without a leading "), _c('em', [_vm._v("0 (zero)")]), _vm._v(" or "), _c('em', [_vm._v("spaces")])])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.whatsappChannelId && !_vm.isAuthed) ? _c('div', {
    staticClass: "dialog-body text-center"
  }, [(!_vm.whatsappQRCode) ? _c('div', {
    staticClass: "loader"
  }, [_c('social-icon', {
    staticClass: "fa fa-fw",
    attrs: {
      "type": 'WhatsApp'
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.loadingWhatsappQRCodeRequest) ? _c('div', {
    staticClass: "loader-text"
  }, [_vm._v("\n      Waiting for QR Code.\n      "), _c('i', {
    staticClass: "fa fa-spinner fa-pulse"
  })]) : _vm._e(), _vm._v(" "), (!_vm.loadingWhatsappQRCodeRequest && !_vm.whatsappQRCode) ? _c('div', {
    staticClass: "info-text"
  }, [_c('h2', [_vm._v("Please follow the instructions carefully.")]), _vm._v(" "), _c('p', [_vm._v("On your mobile device within "), _c('strong', [_vm._v("WhatsApp")]), _vm._v(",\n        go to Settings "), _c('strong', [_vm._v("WhatsApp Web/Desktop")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-arrow-right"
  }), _vm._v(" "), _c('strong', [_vm._v("Scan QR Code")]), _vm._v(".\n        Once your phone's camera is "), _c('strong', [_vm._v("ready")]), _vm._v("\n        click the "), _c('em', [_vm._v("Request QR Code")]), _vm._v(" button below.")]), _vm._v(" "), _c('p', [_vm._v("When the QR code displays you will have around "), _c('strong', [_vm._v("10 to 15 seconds")]), _vm._v("\n        to scan the code before it will time out automatically, if you're unable  to scan it\n        within this time, you will return back to this screen and will be able to request a new\n        QR code.")]), _vm._v(" "), _c('p', [_vm._v("Once your mobile device has been linked, this window will close automatically.\n        Your mobile device will need to stay "), _c('strong', [_vm._v("powered on")]), _vm._v("\n        and "), _c('strong', [_vm._v("connected to the internet")]), _vm._v(" for your messages to be received by us.")])]) : _vm._e(), _vm._v(" "), (_vm.whatsappQRCode) ? _c('div', {
    staticClass: "qrcode"
  }, [_vm._v("\n      This QR code will expire in "), _c('strong', [_vm._v(_vm._s(_vm.expiryCounter))]), _vm._v(" seconds.\n      "), _c('qrcode', {
    attrs: {
      "text": _vm.whatsappQRCode,
      "size": 460
    }
  })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.isAuthed) ? _c('div', {
    staticClass: "dialog-body"
  }, [_c('div', {
    staticClass: "loader"
  }, [_c('social-icon', {
    staticClass: "fa fa-fw",
    attrs: {
      "type": 'WhatsApp'
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "info-text"
  }, [_c('h2', [_vm._v("Success.")]), _vm._v(" "), _c('p', [_vm._v("Your account has been linked "), _c('strong', [_vm._v("successfully")]), _vm._v(",\n        from time to time it may happen that\n        WhatsApp "), _c('strong', [_vm._v("expires")]), _vm._v(" your session, when this happens,\n        simply follow this process of linking your number again.")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "text-danger"
  }, [_c('small', [_c('em', [_vm._v("Please note this feature is HIGHLY EXPERIMENTAL!")])])]), _vm._v(" "), (!_vm.whatsappChannelId && !_vm.isAuthed) ? _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "disabled": !_vm.validMobileNumber || _vm.loadingWhatsappCreateChannel,
      "plain": ""
    },
    on: {
      "click": _vm.createChannel
    }
  }, [(_vm.loadingWhatsappCreateChannel) ? _c('i', {
    staticClass: "fa fa-spin fa-spinner"
  }) : _vm._e(), _vm._v(" Link\n    ")])], 1) : _vm._e(), _vm._v(" "), (_vm.whatsappChannelId && !_vm.isAuthed) ? _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(!_vm.whatsappQRCode) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": _vm.generateQRCode
    }
  }, [_vm._v("Request QR Code")]) : _vm._e(), _vm._v(" "), (_vm.whatsappQRCode) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("Accept")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.isAuthed) ? _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("Accept")])], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-03cc1ac0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/channel/whatsappweb/WhatsappWebChannelCreateDialog.vue
// module id = 3119
// module chunks = 3